export default function AuthField({ children, error, label }) {
  return (
    <div className="group/field space-y-2">
      <label className="flex min-w-0 items-center gap-2 text-[11px] font-semibold tracking-[0.04em] text-muted-foreground transition-colors group-focus-within/field:text-primary">
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-primary/35 transition-all group-focus-within/field:bg-primary group-focus-within/field:shadow-[0_0_0_4px_hsl(var(--primary)/0.1)]" />
        {label}
      </label>
      {children}
      {error ? <div className="text-xs text-destructive">{error}</div> : null}
    </div>
  );
}
